import React, { FC, useState } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';
import ICONS from '../../constants/icons';
import {
    ActionButton,
    ToastStatus,
} from '../../constants/toastMessage.constants';

import ToastMessage from './ToastMessage';

export interface InlineNotificationProps {
    status: ToastStatus;
    title: string;
    description?: string;
    actionButton?: ActionButton;
    displayIcon?: boolean;
    closeButton?: boolean;
    className?: string;
    learnMoreAction?: () => void;
}
const InlineNotification: FC<InlineNotificationProps> = ({
    status,
    title,
    description,
    actionButton,
    displayIcon = false,
    closeButton = false,
    className,
    learnMoreAction,
}) => {
    const [isWarningVisible, setIsWarningVisible] = useState(true);

    const renderToastIcon = () => {
        switch (status) {
            case ToastStatus.Success:
                return (
                    <ICONS.circleCheck
                        style={{ color: aampeTheme.toastIconColor[status] }}
                        size={20}
                    />
                );
            case ToastStatus.Error:
                return (
                    <ICONS.circleCross
                        style={{ color: aampeTheme.toastIconColor[status] }}
                        size={20}
                    />
                );
            case ToastStatus.Warning:
                return (
                    <ICONS.warning
                        style={{ color: aampeTheme.toastIconColor[status] }}
                    />
                );
            case ToastStatus.Info:
                return (
                    <ICONS.fillInfo
                        style={{ color: aampeTheme.toastIconColor[status] }}
                        size={20}
                    />
                );
            default:
                return null;
        }
    };
    if (!isWarningVisible) return null;

    return (
        <Container
            isPlainToast={!displayIcon}
            type={status}
            className={className}
        >
            <ContentWrapper>
                {displayIcon && renderToastIcon()}
                <ToastMessage
                    status={status}
                    title={title}
                    description={description}
                    actionButton={actionButton}
                />
            </ContentWrapper>
            {closeButton && (
                <XClose onClick={() => setIsWarningVisible(false)} />
            )}
            {learnMoreAction && (
                <LearnMore onClick={learnMoreAction}>Learn more</LearnMore>
            )}
        </Container>
    );
};
const Container = styled.div<{ type: ToastStatus; isPlainToast: boolean }>(
    ({ type, isPlainToast }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'start',
        border: isPlainToast
            ? ''
            : `1px solid ${aampeTheme.toastIconColor[type]}`,
        padding: isPlainToast ? '' : aampeTheme.spacing4(4),
        borderRadius: isPlainToast ? '' : aampeTheme.borderRadius.default,
        backgroundColor: isPlainToast
            ? ''
            : aampeTheme.toastInlineBgColor[type],
        width: '100%',
        height: '100%',
    }),
);
const ContentWrapper = styled.div({
    display: 'flex',
    gap: aampeTheme.spacing4(3),
    alignItems: 'start',
});
const XClose = styled(ICONS.xIcon)(() => ({
    cursor: 'pointer',
    color: aampeTheme.toastIconColor.info,
    height: '14px',
    width: '14px',
}));
const LearnMore = styled.span({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: aampeTheme.size.font.textMedium,
    fontWeight: aampeTheme.weights.heavy,
    lineHeight: aampeTheme.size.lineHeight.small,
    color: aampeTheme.colors.solidA02,
});
export default InlineNotification;
